import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appModalDialog]',
    standalone: false
})
export class ModalDialogDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
